import { render } from "./SecondarySelection.vue?vue&type=template&id=2c41af6e&scoped=true"
import script from "./SecondarySelection.vue?vue&type=script&lang=js"
export * from "./SecondarySelection.vue?vue&type=script&lang=js"

import "./SecondarySelection.vue?vue&type=style&index=0&id=2c41af6e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c41af6e"]])

export default __exports__